
export default {
    props: {
        city: Object,
        reviews: Array
    },
    data() {
        return {
            scoreGlobal: 0,
            notSubmitted: true,
            commentFormVisible: null,
            activeCommentIdLocal: null, // Initialize with prop value
        }
    },
    methods: {
        redirectToNewReview: function () {
            this.$router.push({
                name: 'post-avis',
                query: { city: this.city.slug, global: this.scoreGlobal }
            });
        },
        toggleCommentForm(id) {

            if (this.commentFormVisible === id) {
                this.commentFormVisible = null;
                this.activeCommentIdLocal = null;

            } else {
                this.commentFormVisible = id;
                this.activeCommentIdLocal = 'r-' + id;
            }
        },

        toggleReplyForm(id) {
            this.commentFormVisible = null;
            this.activeCommentIdLocal = id;
        }
    },

}
